import { InvitationAccept } from '@/features/invitations/accept'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const invitationSchema = z.object({
  __clerk_ticket: z.string().optional(),
  __clerk_status: z.enum(['sign_in', 'sign_up']).optional(),
})

export const Route = createFileRoute('/invitations/accept')({
  component: InvitationAccept,
  validateSearch: invitationSchema,
})
